import { render, staticRenderFns } from "./PriceSetupView.vue?vue&type=template&id=39c9056c&scoped=true&"
import script from "./PriceSetupView.vue?vue&type=script&lang=ts&"
export * from "./PriceSetupView.vue?vue&type=script&lang=ts&"
import style0 from "./PriceSetupView.vue?vue&type=style&index=0&id=39c9056c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c9056c",
  null
  
)

export default component.exports